
import {Interval, DateTime} from 'luxon';

const DATA_LIMITS = Interval.fromDateTimes(DateTime.utc(1880, 1, 1, 12), DateTime.utc(2020, 1, 1, 12));

export {DATA_LIMITS};